import React from 'react';
import './Input.scss';

const Input = ({ className, label, error, ...rest }) => {
  return (
    <div className="input" data-testid="input-container">
      <input type="text" className={`input__input ${className}`} autoComplete="off" error={error} {...rest} />
      <label className={`input__label`}>{label}</label>
      <span className="input__bar" />
      {error ? <span className="input__error" data-testid="input-error">{error}</span> : null}
    </div >
  )
}

export default Input;
